module.exports = __webpack_public_path__ + "img/prop-2.0bae463f.png";